export enum ETipoItemCenarioFiscal {
    Produto = 1,
    Ncm = 2,
    Geral = 3
}
